import { TranscriptCategories } from '../model/transcript-categories.model';

export function filterSummaryByBehaviour(
    behaviourId: number | null,
    categories: TranscriptCategories[],
): TranscriptCategories[] {
    if (behaviourId == null) {
        return [...categories];
    }

    return categories.map((c) => {
        const nextC = { ...c };

        nextC.subCategories = c.subCategories.map((sub) => {
            const nextSub = { ...sub };

            nextSub.transcripts = sub.transcripts.filter((t) => {
                return (
                    t.primaryFocus?.behaviourId === behaviourId ||
                    t.behaviours.some((p) => p.behaviourId === behaviourId)
                );
            });

            return nextSub;
        });

        return nextC;
    });
}
